module.exports = __webpack_public_path__ + "img/wa10.3ff4e295.jpg";